import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Typography,
  Row,
  Col,
  Button,
  Spin,
} from 'antd';
import {
  ArrowLeftOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
import { onError } from 'utils/handlers';
import { patchRecibo } from 'api/recaudacion/recibos';

const { Text } = Typography;

const ModalAuthorize = ({
  visible,
  setVisible,
  reciboId,
  callback,
}) => {
  const [loading, setLoading] = React.useState(false);

  const onFinish = async () => {
    try {
      setLoading(true);
      const authorized = await patchRecibo(reciboId, { estados_globales: 4 });
      if (authorized) {
        await callback(4, authorized);
        setVisible(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const ModalControls = () => (
    <Row className="form-submit-controls">
      <Col xs={24} sm={24} md={0}>
        <Row>
          <Button
            type="link"
            onClick={() => setVisible(false)}
          >
            <ArrowLeftOutlined />
          </Button>
          <Button
            type="link"
            onClick={() => onFinish()}
            className="no-color success"
            icon={<CheckCircleOutlined />}
          />
        </Row>
      </Col>
      <Col xs={0} sm={0} md={24}>
        <Row>
          <Button
            type="link"
            onClick={() => setVisible(false)}
          >
            <ArrowLeftOutlined />
            Regresar
          </Button>
          <Button
            type="link"
            onClick={() => onFinish()}
            style={{ marginLeft: 10 }}
            className="no-color success"
            icon={<CheckCircleOutlined />}
          >
            Autorizar
          </Button>
        </Row>
      </Col>
    </Row>
  );

  return (
    <Modal
      title={(
        <Row justify="space-between">
          <Text>
            Autorización
          </Text>
          <ModalControls />
        </Row>
        )}
      className="modal-delete"
      visible={visible}
      footer={null}
      closable={false}
    >
      <Spin
        tip="Cargando..."
        spinning={loading}
      >
        <Typography.Text style={{ fontSize: 16 }}>
          ¿Desea Autorizar el registro?
        </Typography.Text>
      </Spin>
    </Modal>
  );
};

ModalAuthorize.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  reciboId: PropTypes.number.isRequired,
  callback: PropTypes.func.isRequired,
};

export default ModalAuthorize;
